import { isNullOrUndefined } from '../../type';
import { getDateLocale } from './locale';
import { buildFromWeek, buildWeekRange } from './tokens/week';
import { CONVERTER_MAP, tokenizer } from './convert';
import { buildFromDayOfYear } from './tokens/date';

function createEmptyMatcher(token) {
  return function (str) {
    var matched = str.slice(0, token.length);

    if (matched === token) {
      return matched;
    }

    return false;
  };
}

function createEmptyParser() {
  return function () {
    return {};
  };
}

function buildDate(info, startDay) {
  var year = info.year,
      month = info.month,
      date = info.date,
      week = info.week,
      day = info.day,
      hour = info.hour,
      minute = info.minute,
      second = info.second,
      dateOfYear = info.dateOfYear;

  if (!isNullOrUndefined(hour) || !isNullOrUndefined(minute) || !isNullOrUndefined(second)) {
    if (isNullOrUndefined(month) || isNullOrUndefined(year) || isNullOrUndefined(date)) {
      var newDate = new Date();
      newDate.setHours(hour || 0);
      newDate.setMinutes(minute || 0);
      newDate.setSeconds(second || 0);
      return {
        valid: true,
        exact: true,
        date: newDate
      };
    }

    return {
      valid: true,
      exact: true,
      date: new Date(year, month, date, hour || 0, minute || 0, second || 0)
    };
  }

  if (year == null) {
    throw new Error('year is required');
  }

  try {
    if (month != null && date != null) {
      return {
        valid: true,
        exact: true,
        date: new Date(year, month, date)
      };
    }

    if (week != null && day != null) {
      return {
        valid: true,
        exact: true,
        date: buildFromWeek(year, week, day, startDay)
      };
    }

    if (dateOfYear != null) {
      return {
        valid: true,
        exact: true,
        date: buildFromDayOfYear(year, dateOfYear)
      };
    }

    if (month != null) {
      return {
        valid: true,
        exact: false,
        date: new Date(year, month, 1)
      };
    }

    if (week != null) {
      return {
        valid: true,
        exact: false,
        date: buildWeekRange(year, week !== null && week !== void 0 ? week : 1, startDay)[0]
      };
    }

    return {
      valid: true,
      exact: false,
      date: new Date(year, 0, 1)
    };
  } catch (e) {
    return {
      valid: false,
      message: e.message
    };
  }
}

export function parseDate(str, format, locale) {
  var strict = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (str == null || str === '') {
    return;
  }

  str = str.replace(/\s+/g, '');
  var tokens = tokenizer(format.replace(/\s+/g, ''));
  var valid = true;
  var firstErrorPos = 0;
  var left = str;
  var info = {};
  tokens.map(function (token) {
    if (!valid) {
      return;
    }

    var matchToken = CONVERTER_MAP[token] ? CONVERTER_MAP[token].matchToken : createEmptyMatcher(token);
    var parseToken = CONVERTER_MAP[token] ? CONVERTER_MAP[token].parseToken : createEmptyParser();
    var matched = matchToken(left, getDateLocale(locale));

    if (matched === false) {
      valid = false;
      firstErrorPos = str.length - left.length;
      return;
    }

    Object.assign(info, parseToken(matched, getDateLocale(locale)));
    left = left.slice(matched.length);
  });

  if (!valid) {
    console.error("parse date string error, format = ".concat(format, " str =").concat(str, " pos=").concat(firstErrorPos));
    return;
  }

  var result = buildDate(info, getDateLocale(locale).startDay);

  if (!result.valid) {
    console.error('parse date string error, format = ' + format + ' str =' + str + ' error=' + result.message);
    return;
  }

  if (strict && !result.exact) {
    console.error('parse date string error, format = ' + format + ' str =' + str + ' error= missing required date info, such as month and date');
    return;
  }

  return result.date;
}
export function checkDate(str, format, locale) {
  var strict = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (str === '') {
    return false;
  }

  str = str.replace(/\s+/g, '');
  var tokens = tokenizer(format.replace(/\s+/g, ''));
  var valid = true;
  var left = str;
  var info = {};
  tokens.map(function (token) {
    if (!valid) {
      return;
    }

    var matchToken = CONVERTER_MAP[token] ? CONVERTER_MAP[token].matchToken : createEmptyMatcher(token);
    var parseToken = CONVERTER_MAP[token] ? CONVERTER_MAP[token].parseToken : createEmptyParser();
    var matched = matchToken(left, getDateLocale(locale));

    if (matched === false) {
      valid = false;
      return;
    }

    Object.assign(info, parseToken(matched, getDateLocale(locale)));
    left = left.slice(matched.length);
  });
  if (!valid) return false;
  var result = buildDate(info, getDateLocale(locale).startDay);

  if (!result.valid) {
    console.error('parse date string error, format = ' + format + ' str =' + str + ' error=' + result.message);
    return false;
  }

  if (strict && !result.exact) {
    console.error('parse date string error, format = ' + format + ' str =' + str + ' error= missing required date info, such as month and date');
    return false;
  }

  return true;
}
export function parseDateArr(dateList, format, locale, strict) {
  var ret = [];
  dateList.forEach(function (date) {
    if (typeof date === 'string') {
      var d = parseDate(date, format, locale, strict);

      if (d != null) {
        ret.push(d);
      }
    } else {
      ret.push(date);
    }
  });
  return ret;
}